import { MessageSquare } from "lucide-react";
import PageHeader from "../../components/common/PageHeader";
import WebsiteWidgetSection from "../Integrations/WebsiteWidgetSection";

export default function WebsiteWidgetSettingsPage() {
  return (
    <div className="p-6 bg-[#f5f6f7] min-h-[calc(100vh-80px)] space-y-6">
      <div>
        <PageHeader
          icon={MessageSquare}
          title="Website Widget"
          subtitle="Configure your website WhatsApp widget separately from API and webhook integrations."
        />
      </div>

      <WebsiteWidgetSection />
    </div>
  );
}
